import { useCallback, useState } from 'react'
import { ApiError } from '../api/client'
import { companiesApi } from '../api/companies'

/**
 * Starts the QuickBooks consent flow.
 *
 * Connecting leaves the SPA entirely — the browser goes to Intuit and comes back
 * to `/api/companies/callback`, which redirects to the app. So there is no
 * "result" to handle here: success means the page navigated away, and the only
 * outcome this hook can report is a failure to *start*.
 *
 * Shared by the Switch Company screen and the first-run welcome page so the two
 * cannot drift on which endpoint they call or how they report a failure.
 */
export function useConnectCompany() {
  const [connecting, setConnecting] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const connect = useCallback(async () => {
    setConnecting(true)
    setError(null)
    try {
      const { url } = await companiesApi.connectUrl()
      window.location.assign(url)
    } catch (cause: unknown) {
      setError(
        cause instanceof ApiError
          ? cause.message
          : 'Could not start the QuickBooks connection. Please try again.',
      )
      setConnecting(false)
    }
  }, [])

  return { connect, connecting, error }
}
